import React, { useEffect, useState } from 'react'
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Divider } from 'primereact/divider';
import { Fieldset } from 'primereact/fieldset';
import { travelService } from '../../services/extensions';
import { toast } from "react-toastify";
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from "primereact/dialog";
import { Card } from 'react-bootstrap'; 
import { Panel } from 'primereact/panel';
import moment from 'moment';
import { TravelStatus } from '../../common/util/constants';
const AllRequest = () => {
    const [selectedLeave, setSelectedLeave] = useState([]);
    const [buOptions, setBuOptions] = useState([]);
    const [filter, setFilter] = useState({
        businessUnitId: '',
        userName: ''
    });
    const [leaveInReview, setLeaveInReview] = useState([]);
    const [visible, setVisible] = useState(false);
    const [selectedTravelRecord, setSelectedTravelRecord] = useState(null);

    useEffect(() => {
        fetchBuOptions();
        fetchFilteredData();
    }, []);

    useEffect(() => {
        if (filter.businessUnitId || filter.userName) {
            fetchFilteredData();
        }
    }, [filter]);

    const fetchBuOptions = async () => {
        try {
            const response = await travelService.GetAllBusinessUnit();
            const buOptions = response.data.data.map(bu => ({
                label: bu.title,
                value: bu.id
            }));
            setBuOptions(buOptions);
        } catch (error) {
            toast.error('Failed to load business units');
        }
    };

    const fetchFilteredData = async () => {
        try {
            const response = await travelService.getAllTravelRequestBuwiseandsearchByECN(filter);
            const rejectedTravels = response.data.data
                .map(user => ({
                    ...user,
                    Travels: user.Travels.filter(travel => travel.status === TravelStatus.REJECTED_BY_HR_HEAD)
                }))
                .filter(user => user.Travels.length > 0);
            setLeaveInReview(rejectedTravels);
        } catch (error) {
            toast.error('Failed to fetch filtered data');
        }
    };

    const handleBUChange = (e) => {
        setFilter(prev => ({
            ...prev,
            businessUnitId: e.value
        }));
    };

    const handleUserNameChange = (e) => {
        setFilter(prev => ({
            ...prev,
            userName: e.target.value
        }));
    };

    const handleViewDetail = (rowData) => {
        setSelectedTravelRecord(rowData);
        setVisible(true);
    };

    const Designationtitle = (rowData) => {
        return <div>
            <p>{rowData?.Designation?.title}</p>
        </div>
    }

    const BusinessUnittitle = (rowData) => {
        return <div>
            <p>{rowData?.BusinessUnit?.title}</p>
        </div>
    }

    const projectBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                {rowData.Allocations.map(allocation => (
                    <div key={allocation.id}>
                        {allocation.Project?.title} ({allocation.percentage}%)
                    </div>
                ))}
            </React.Fragment>
        );
    };

    const userNameTemplate = (rowData) => {
        return `${rowData.firstName} ${rowData.lastName}`;
    };

    const requestedDateTemplate = (rowData) => {
        if (rowData.Travels && rowData.Travels.length > 0) {
            return moment(rowData.Travels[0].createdAt).format('DD/MM/YYYY');
        }
        return 'N/A';
    };

    const journeyDateTemplate = (rowData) => {
        if (rowData.Travels && rowData.Travels.length > 0) {
            return rowData.Travels[0].journeyDate ? moment(rowData.Travels[0].journeyDate).format('DD/MM/YYYY') : 'N/A';
        }
        return 'N/A';
    };

    const lastApprovedDateTemplate = (rowData) => {
        if (rowData.Travels && rowData.Travels.length > 0) {
            return moment(rowData.Travels[0].updatedAt).format('DD/MM/YYYY');
        }
        return 'N/A';
    };

    const actionBody = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-eye" className="p-button-rounded p-button-secondary mr-2" onClick={() => handleViewDetail(rowData)} />
            </React.Fragment>
        )
    };

    return (
        <>
            <div className="col-12">
                <div className="tabview-demo col-12">
                    <Fieldset>
                        <h1>Team Members - All Request</h1>
                        <Divider />
                        <div className="formgrid grid mt-4">
                            <div className="field col-4">
                                <label className="font-bold block mb-2">Search By BU</label>
                                <Dropdown
                                    value={filter.businessUnitId}
                                    options={buOptions}
                                    onChange={handleBUChange}
                                    placeholder="Select Business Unit"
                                    className="w-full"
                                />
                            </div>
                            <div className="field col-4">
                                <label className="font-bold block mb-2">Search By User or ECN</label>
                                <InputText
                                    value={filter.userName}
                                    onChange={handleUserNameChange}
                                    placeholder="Enter username or ECN"
                                    className="w-full"
                                />
                            </div>
                            {/* <div className="field col-4">
                                <label className="font-bold block mb-2">&nbsp;</label>
                                <Button label="Export in excel" icon="pi pi-download" aria-label="Save" severity="primary" />
                            </div> */}
                        </div>

                        <DataTable
                            className="mt-4 travels-data"
                            paginator
                            responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                            dataKey="id"
                            value={leaveInReview}
                            selection={selectedLeave}
                            onSelectionChange={(e) => setSelectedLeave(e.value)}
                            resizableColumns
                            columnResizeMode="fit"
                            scrollable="horizontal"
                            stripedRows
                            editMode="row"
                        >
                            {console.log(leaveInReview)}
                            <Column selectionMode="multiple"></Column>
                            <Column header="Requested Date" body={requestedDateTemplate} />
                            <Column header="ECN" field='ecn'/>
                            <Column header="User Name" body={userNameTemplate} />
                            <Column header="Designation" body={Designationtitle} />
                            <Column header="BU" body={BusinessUnittitle} />
                            <Column header="Project" body={projectBodyTemplate} />
                            <Column header="Travel Date" body={journeyDateTemplate} />
                            <Column header="Rejected Date" body={lastApprovedDateTemplate} /> 
                            <Column header="Action" body={actionBody} />
                        </DataTable>
                    </Fieldset>

                    <Dialog header="Travel Detail- ID" visible={visible} style={{ width: '95vw' }} onHide={() => setVisible(false)}>
                        {selectedTravelRecord && selectedTravelRecord.Travels.map((travel, index) => (
                            <Panel key={travel.id} className='traveldetail'>
                                <div className='formgrid grid'>
                                    <div className='col-12'>
                                        <Card>
                                            <div className='d-flex-space-bet'>
                                                <h1>Traveler Detail {index + 1}</h1>
                                            </div>
                                            <div className="formgrid grid">
                                                <div className='field col-2 single-category'>
                                                    <h2>Trip Type</h2>
                                                    <p>{travel.tripType}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Visa Type</h2>
                                                    <p>{travel.visaType}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>User ECN</h2>
                                                    <p>{travel.empEcn}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Manager ECN</h2>
                                                    <p>{travel.managerEcn}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Traveller Name</h2>
                                                    <p>{selectedTravelRecord.firstName} {selectedTravelRecord.lastName}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Traveller Initiated By</h2>
                                                    <p>{travel.createdBy}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Surname</h2>
                                                    <p>{selectedTravelRecord.lastName}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>User Name</h2>
                                                    <p>{selectedTravelRecord.firstName}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Designation</h2>
                                                    <p>{selectedTravelRecord.Designation.title}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Mobile Number</h2>
                                                    <p>{selectedTravelRecord.phone}</p>
                                                </div>
                                                <div className='field col-4 single-category'>
                                                    <h2>Email ID</h2>
                                                    <p>{selectedTravelRecord.email}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Grade</h2>
                                                    <p>{travel.grade}</p>
                                                </div>
                                                <div className='field col-6 single-category'>
                                                    <h2>Traveller Comments</h2>
                                                    <p>{travel.comment}</p>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>
                                    <div className='col-12'>
                                        <Card>
                                            <div className='d-flex-space-bet'>
                                                <h1>Traveller Detail</h1>
                                            </div>
                                            <div className="formgrid grid">
                                                <div className='field col-2 single-category'>
                                                    <h2>Client Name</h2>
                                                    <p>{travel.clientId}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Project Name</h2>
                                                    <p>{travel.projectId}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Project Manager</h2>
                                                    <p>{travel.managerEcn}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>BU/Functional Head</h2>
                                                    <p>{travel.buHead}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Country of Visit</h2>
                                                    <p>{travel.countryofVisit}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>State/Cities</h2>
                                                    <p>{travel.states}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Journey Date</h2>
                                                    <p>{travel.journeyDate}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Return Date</h2>
                                                    <p>{travel.returnDate}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Cost Center</h2>  
                                                    <p>{travel.costCenter}</p>                                              <p>{travel.costCenter}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>DA Currency</h2>
                                                    <p>{travel.daCurrency}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>DA Entitle Amount</h2>
                                                    <p>{travel.daentitleAmmount}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Seat Request</h2>
                                                    <p>{travel.seatRequest}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Meal Request</h2>
                                                    <p>{travel.mealRequest}</p>
                                                </div>
                                                <div className='field col-6 single-category'>
                                                    <h2>Frequently Flyer Number</h2>
                                                    <p>{travel.frequentflyerNumber}</p>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>
                                    <div className='col-12'>
                                        <Card>
                                            <div className='d-flex-space-bet'>
                                                <h1>Passport Detail</h1>
                                            </div>
                                            <div className="formgrid grid">
                                                <div className='field col-2 single-category'>
                                                    <h2>Passport Number</h2>
                                                    <p>{travel.travelDetails[0]?.passportNumber}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Date of Birth</h2>
                                                    <p>{travel.travelDetails[0]?.dateOfBirth}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Place of Issue</h2>
                                                    <p>{travel.travelDetails[0]?.placeOfIssue}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Issue of Passport</h2>
                                                    <p>{travel.travelDetails[0]?.dateOfIssueOfPassport}</p>
                                                </div>
                                                <div className='field col-2 single-category'>
                                                    <h2>Expire In Passport</h2>
                                                    <p>{travel.travelDetails[0]?.dateOfexpireOfPassport}</p>
                                                </div>
                                                <div className='field col-6 single-category'>
                                                    <h2>Address as per the Passport</h2>
                                                    <p>{travel.travelDetails[0]?.addressAsPerthefPassport}</p>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>
                                    <div className='col-12'>
                                        <Card>
                                            <div className='d-flex-space-bet'>
                                                <h1>Insurance Detail</h1>
                                            </div>
                                            <div className="formgrid grid">
                                                <div className='field col-4 single-category'>
                                                    <h2>Current Residence Address</h2>
                                                    <p>{travel.travelDetails[0]?.currentResidenceAddress}</p>
                                                </div>
                                                <div className='field col-4 single-category'>
                                                    <h2>Nominee Name</h2>
                                                    <p>{travel.travelDetails[0]?.nomineeName}</p>
                                                </div>
                                                <div className='field col-4 single-category'>
                                                    <h2>Relation With Nominee</h2>
                                                    <p>{travel.travelDetails[0]?.relationWithNominee}</p>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>
                                </div>
                            </Panel>
                        ))}
                    </Dialog>
                </div>
            </div>
        </>
    );
};

export default AllRequest;
